import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import ProgressiveImage from "react-progressive-image";
import "slick-carousel/slick/slick-theme.css";
class BannerSlider extends Component {
    state = {
        tags : [],
    };

    
    render() {

        const settings = {
			dots: false,
			infinite: true,
			speed: 500,
			adaptiveHeight: true,
			autoplay: true,
			fade: false,
            arrows : false,

			
			infinite: true,
		
			slidesToShow: 1,
			
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: true,
                    dots: true
                    
				  }
				},
				{
					breakpoint: 768,
					settings: {
					  slidesToShow: 1,
					  slidesToScroll: 1
					}
				}
				]
			};
		return (
            <React.Fragment >
          
          {this.props.slides.length > 0 &&(
                <Slider {...settings} >
                {this.props.slides.map(tag => (
                    tag.type === this.props.type && (
                    <DelayLink  to={'/single-store-view-more/'+tag.item_group_id}>
                        <div className="text-center" key={tag.id}>
                           
                        <ProgressiveImage
						delay={100}
                        src={'https://pykin.in'+ tag.image}
						placeholder={'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/blue_placeholder'}
					    >
						{(src, loading) => (
						 <img style={{borderRadius: '6px'}} height={loading ? '195px' : this.props.height} width={this.props.width} src={src} alt={'pykin-fresh'}/>
						)}
					</ProgressiveImage>	
                        </div>
                        </DelayLink>
                    )
                ))}
                </Slider>
            )}
            </React.Fragment>
        );
    }
}

export default BannerSlider;